module.exports = __webpack_public_path__ + "img/bg.de033a30.png";